/**
 * @param {string} label - The active tab label to set
 */
export const setActiveTabLabel = (label) => {
    sessionStorage.setItem('activeTabLabel', label);

    // Dispatch custom event to notify LayoutContext
    window.dispatchEvent(
        new CustomEvent('activeTabChanged', {
            detail: { activeTabLabel: label },
        }),
    );
};
